export default __webpack_public_path__ + "static/media/placeholder_business03-en-web.93e23ae9.png";